<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button
            variant="success"
            class="btn-icon position-relative"
            v-b-tooltip
            v-bind:title="$t('operations.add')"
            @click="onPixelSelected(null)"
        >
          <i class="fa-solid fa-bullhorn"></i>
          <i
              class="fa-solid fa-plus position-absolute"
              style="font-size: 0.6em; top: 14px; right: 1px;"
          ></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>

    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <!-- Tabs with tables -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t("menu.pixels") }}</h5>
      </b-card-header>
      <b-card-body>
            <pixels-table
                ref="pixelTable1"
                v-bind:filters="filter"
                v-bind:columns="columns"
                :has-selection="false"
                @selected="onPixelSelected"
                :lazy="true"
            />

      </b-card-body>
    </b-card>

    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="pixels" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <pixel-modal ref="pixel-modal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import PixelSearchRequest from '@/model/campaign/PixelSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Pixel from '@/model/campaign/Pixel'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import PixelModal from '@/components/modal/pixelModal'
import FilterCard from '@/components/widget/FilterCard'
import PixelFilterFields from '@/model/filter/PixelFilterFields'
import PixelsTable from '@/components/tables/PixelTable'

export default {
  name: 'PixelsView',
  components: {
    PixelsTable,
    FilterCard,
    PixelModal,
    ColumnsModal,
    BreadcrumbButton
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Pixel()),
      filter: PixelSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = PixelFilterFields()
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('pixel', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onPixelSelected(selectedId) {
      this.$refs['pixel-modal'].showModal(selectedId)
    },
  }
}
</script>
